import {
  SEARCH_GDPR_URL,
  CREATE_GDPR_URL,
  UPDATE_GDPR_URL,
  INFORMATION_REQUEST_TYPE,
  RECTIFY_REQUEST_TYPE,
  DELETE_REQUEST_TYPE
} from 'app/utils/Constants';

import {
  get,
  post,
  put
} from 'app/services/ApiService';

export const searchGdprSubject = async params => {
  return await get(SEARCH_GDPR_URL(params));
}

const createGdprRequest = async params => {
  return await post(CREATE_GDPR_URL(), params);
}

const updateGdprRequest = async (uuid, params) => {
  return await put(UPDATE_GDPR_URL(uuid), params);
}

export const anonymizeGdprSubject = async (userIds, force = false) => {
  let { uuid } = await createGdprRequest({
    request_type: DELETE_REQUEST_TYPE,
    user_ids: userIds,
    force_image_delete: force
  });

  return await updateGdprRequest(uuid, {
    perform: true
  });
}

export const downloadGdprSubject = async userIds => {
  let { uuid } = await createGdprRequest({
    request_type: INFORMATION_REQUEST_TYPE,
    user_ids: userIds
  });

  let file = await updateGdprRequest(uuid, {
    perform: true,
    download_file: true
  });

  let filename = 'cl-personal-data-' + uuid + '.zip';

  let url = URL.createObjectURL(new Blob([new Uint8Array(file.data)], {
    type: file.headers('Content-Type'),
    name: filename
  }));

  let link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}
